'use strict';

var React = require('react');

var SvgLiveFilledIcon = function SvgLiveFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.273 6.28c-2.05 2.05-2.05 5.375 0 7.425.293.293.293.768 0 1.06-.293.293-.768.293-1.06 0-2.637-2.635-2.637-6.91 0-9.545.292-.293.767-.293 1.06 0 .293.293.293.767 0 1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.75c-1.243 0-2.25 1.007-2.25 2.25s1.007 2.25 2.25 2.25 2.25-1.007 2.25-2.25-1.007-2.25-2.25-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.712 13.705c2.05-2.05 2.05-5.374 0-7.425-.293-.293-.293-.767 0-1.06.293-.293.768-.293 1.061 0 2.636 2.636 2.636 6.91 0 9.546-.293.293-.768.293-1.06 0-.293-.293-.293-.768 0-1.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29 8.048c-1.073 1.074-1.073 2.815 0 3.89.294.292.294.767 0 1.06-.292.293-.767.293-1.06 0-1.66-1.66-1.66-4.35 0-6.01.293-.293.768-.293 1.06 0 .294.292.294.767 0 1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.694 11.937c1.074-1.074 1.074-2.815 0-3.889-.292-.293-.292-.768 0-1.06.293-.293.768-.293 1.061 0 1.66 1.66 1.66 4.35 0 6.01-.293.293-.768.293-1.06 0-.293-.293-.293-.768 0-1.06Z"
  }));
};
SvgLiveFilledIcon.displayName = "LiveFilledIcon";

exports.SvgLiveFilledIcon = SvgLiveFilledIcon;
